import FixedValueComponent from './FixedValueComponent';
export default FixedValueComponent;
